import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ClusterWithSite } from '../../sections/types/ClusterWithSite';

export interface IFetchAllClustersParams {
}

export interface IFetchAllClustersResult extends IResult {
  success?: ReadonlyArray<ClusterWithSite>;
}

export class FetchAllClusterstRequest extends Request<IFetchAllClustersParams, IFetchAllClustersResult> {
  constructor(params: IFetchAllClustersParams) {
    super('fetchAllClusters', params);
  }
}
